<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import i18n from '@/language';
export default {
  name: 'App',
  created(){
    if(window.location.href.includes("/zh")){
      i18n.locale = 'TC';
    }else{
      i18n.locale = 'EN';
    }
    /*
    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);
    if(params.get("lang") != null){
      if(params.get("lang") == 'TC'){
        i18n.locale = 'TC';
      }else{
        i18n.locale = 'EN';
      }
    }else {
      i18n.locale = 'TC';
    }
    */
  } 
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue